<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Vehicle
              </v-btn>
              <v-menu
                v-model="menuBulkVehicle"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Bulk Vehicle
                  </v-btn>
                </template>

                <v-card>
                  <v-card-text>
                    <v-file-input
                      v-model="fileBulkVehicle"
                      label="File input"
                      outlined
                      dense
                      prepend-icon="mdi-file-upload-outline"
                    ></v-file-input>
                    <v-card-actions>
                      <a
                        class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default info"
                        href="/file/fms_vehicles_template_0.1.csv"
                      >
                        <v-icon color="white">mdi-file-download-outline</v-icon>
                        Template
                      </a>
                      <v-spacer></v-spacer>
                      <v-btn
                        :disabled="btnBulkLoad || fileBulkVehicle == null"
                        :loading="btnBulkLoad"
                        @click="getFileBulk"
                        color="success"
                      >
                        Upload
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex flex-wrap">
                <!-- filter date -->
                <!-- <div class="shadow d-flex">
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <p class="mt-5 fs-small">s/d</p>
                  <div class="mt-5 mx-5">
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                  <v-btn :disabled="!search" class="mt-5" small color="primary">
                    <v-icon>mdi-calendar-filter</v-icon>
                  </v-btn>
                </div> -->
                <v-select
                  style="max-width: 150px"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>
            <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
            >
              <!-- <template v-slot:[`header.vehicle_business_unit`]="{ header }">
                <v-select
                  style=" font-size:10px;"
                  :items="optionBusinessUnit"
                  :label="header.text"
                  v-model="valueBusinessUnit"
                  @change="getList"
                  item-text="business_unit_name"
                  item-value="id"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template> -->

              <template v-slot:[`header.vehicle_status`]="{ header }">
                <v-select
                  style="font-size: 10px"
                  :items="optionVehicleStatus"
                  :label="header.text"
                  v-model="valueVehicleStatus"
                  @change="getList"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
              </template>
              <!-- <template v-slot:[`item.detail`]="{ item }">
          <router-link :to="{name: 'Detail Vehicle', params: { id: item.id }}" class="btn btn-primary">Detail
          </router-link>
    </template> -->
              <!-- <template v-slot:[`item.vehicle_business_unit`]="{ item }">
                {{ item.vehicle_business_unit.business_unit_name }}
              </template> -->

              <template v-slot:[`item.vehicle_status`]="{ item }">
                <span v-if="item.vehicle_status == 0">Registered</span>
                <span v-if="item.vehicle_status == 1">Waiting Approval</span>
                <span v-if="item.vehicle_status == 2">Rejected</span>
                <span v-if="item.vehicle_status == 3">Waiting PKO</span>
                <span v-if="item.vehicle_status == 4">Active</span>
                <span v-if="item.vehicle_status == 5">Payment Complete</span>
                <span v-if="item.vehicle_status == 6"
                  >Terminate By Payment</span
                >
                <span v-if="item.vehicle_status == 7">Active Ownership</span>
                <span v-if="item.vehicle_status == 8">{{
                  item.vehicle_return_date
                    ? "Repo at " +
                      $moment(item.vehicle_return_date).format("DD-MM-YYYY")
                    : "Repo"
                }}</span>
                <span v-if="item.vehicle_status == 9">{{
                  item.vehicle_return_date
                    ? "Return at " +
                      $moment(item.vehicle_return_date).format("DD-MM-YYYY")
                    : "Return"
                }}</span>
                <span v-if="item.vehicle_status == 10"
                  >STNK Problem (STNK {{ item.vehicle_stnk_status }})</span
                >
                <span v-if="item.vehicle_status == 11"
                  >Key Problem (Key {{ item.vehicle_key_status }})</span
                >
                <span v-if="item.vehicle_status == 12"
                  >STNK & Key Problem (STNK {{ item.vehicle_stnk_status }} & Key
                  {{ item.vehicle_key_status }})</span
                >
                <span v-if="item.vehicle_status == 13">In Service</span>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="detailVehicle(item.id)">
                      <v-list-item-title x-small>Detail</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.update"
                      @click="editVehicle(item.id)"
                    >
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="role.delete && item.vehicle_status == 0"
                      @click="deleteConfirmation(item.id)"
                    >
                      <v-list-item-title x-small>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalDetailPage">
      <template v-slot:body>
        <detail-vehicle :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal>
    <modal ref="modalAddPage">
      <template v-slot:header>
        <div style="text-align: center; margin: auto">
          <h3>Add Vehicle</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAdd()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-vehicle />
      </template>
    </modal>
    <modal ref="modalEditPage">
      <template v-slot:header>
        <div style="text-align: center; margin: auto">
          <h3>Edit Vehicle</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseEdit()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <edit-vehicle :data_id="$refs.modalEditPage.data" />
      </template>
    </modal>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import JsonExcel from "vue-json-excel";
import cvsToJson from "convert-csv-to-json";
import AddVehicle from "@/pages/Dashboard/Fms/Vehicle/AddVPage.vue";
import EditVehicle from "@/pages/Dashboard/Fms/Vehicle/EditVPage.vue";
import DetailVehicle from "@/pages/Dashboard/Fms/Vehicle/DetailVPage.vue";
import { Modal } from "@/components";
import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    "add-vehicle": AddVehicle,
    "detail-vehicle": DetailVehicle,
    "edit-vehicle": EditVehicle,
  },
  vuetify,
  data() {
    return {
      mounted: true,
      // valueBusinessUnit: 0,
      // optionBusinessUnit: null,
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Vehicle No.", value: "vehicle_door_no" },
        { text: "Police No.", value: "vehicle_plate_no" },
      ],
      valueVehicleStatus: "",
      optionVehicleStatus: [
        { text: "All", value: "" },
        { text: "Return", value: "9" },
        { text: "Repo", value: "8" },
        { text: "STNK Problem", value: "10" },
        { text: "Key Problem", value: "11" },
        { text: "In Service", value: "13" },
        { text: "STNK & Key Problem", value: "12" },
        { text: "Active Ownership", value: "7" },
        { text: "Terminated by Payment", value: "6" },
        { text: "Payment Completed", value: "5" },
        { text: "Active", value: "4" },
        { text: "Waiting PKO", value: "3" },
        { text: "Rejected", value: "2" },
        { text: "Waiting Approval", value: "1" },
        { text: "Registered", value: "0" },
      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: false,
      role: "",
      search: "",
      options: {},
      headers: [
        {
          text: "Actions",
          align: "start center",
          value: "actions",
          sortable: false,
        },
        // {
        //   text: 'Detail',
        //   align: 'start center',
        //   value: 'detail',
        //   sortable: false
        // },
        { text: "Vehicle No.", value: "vehicle_door_no" },
        { text: "Police No.", value: "vehicle_plate_no" },
        // {
        //   text: "Business Unit",
        //   value: "vehicle_business_unit",
        //   sortable: false,
        // },
        { text: "Status.", value: "vehicle_status", sortable: false },
        { text: "Updated At", value: "updated_at", align: "center" },
      ],
      table: [],
      worksheetName: "Vehicles",
      fileName: "Vehicles.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      field_export: {
        No: "no",
        "Current Status": "vehicle_current_status",
        "Current General Status": "vehicle_general_current_status",
        "Vehicle No": "vehicle_door_no",
        "Plate No": "vehicle_plate_no",
        // "Business Unit": "vehicle_business_unit",
        Model: "vehicle_model",
        "Fuel Type": "vehicle_fuel_type",
        "Body Color": "vehicle_body_color",
        "Plate Color": "vehicle_plate_color",
        "Registration Year": "vehicle_registration_year",
        "Registration Name": "vehicle_registration_name",
        "Production Year": "vehicle_production_year",
        "Chassis No": "vehicle_chassis_no",
        "Engine No": "vehicle_engine_no",
        "No Document": "no_document",
        "Document Type": "vehicle_document_type",
        "Document No": "vehicle_document_no",
        "Documenr Expire Date": "vehicle_document_expire_date",
        "Document Tax Expire Date": "vehicle_document_tax_expire_date",
        "Document Remark": "vehicle_document_remark",
        "No Accesory": "no_accesory",
        "Accesory Type": "vehicle_accesory_type",
        "Accesory Serial No": "vehicle_accesory_serial_no",
        "Accesory Installation Date": "vehicle_accesory_installation_date",
        "Accesory Installation By": "vehicle_accesory_installation_by",
        "Accesory Remark": "vehicle_accesory_remark",
        "MSPF Last Activation Status": "vehicle_mspf_last_activation_status",
        "MSPF Last Communication Status":
          "vehicle_mspf_last_communication_status",
        "Created At": "created_at",
        "Updated At": "updated_at",
      },

      menuBulkVehicle: false,
      fileBulkVehicle: null,
      btnBulkLoad: false,
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
    this.$root.$refs.ListVehiclePage = this;
    //check saat page terbuka apakah ada params
    if (this.$route.params.id) {
      //open detail
      this.detailVehicle(this.$route.params.id);
    }
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    this.onMounted();
    this.getList();
    this.mounted = false;
  },
  methods: {
    // ambil data yang dibutuhkan

    async onMounted() {
      await this.$store.dispatch("fms_business_unit/list");
      this.optionBusinessUnit = await this.$store.getters[
        "fms_business_unit/list"
      ];
      this.optionBusinessUnit.unshift({ business_unit_name: "All", id: 0 });
    },
    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

      // if (this.valueBusinessUnit != 0) {
      //   if (query.filter) {
      //     Object.assign(query.filter, {
      //       vehicle_business_unit: this.valueBusinessUnit,
      //     });
      //   } else {
      //     query.filter = { vehicle_business_unit: this.valueBusinessUnit };
      //   }
      // }

      if (this.valueVehicleStatus != "") {
        if (query.filter) {
          Object.assign(query.filter, {
            vehicle_status: this.valueVehicleStatus,
          });
        } else {
          query.filter = { vehicle_status: this.valueVehicleStatus };
        }
      }

      await this.$store.dispatch("fms_vehicle/list", query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
      this.table = await this.$store.getters["fms_vehicle/list"];
      var pageMeta = await this.$store.getters["fms_vehicle/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },
    searchButton() {
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      // if(this.$refs.vTable){
      //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
      // }
      // else{
      //   this.exportAllFitered = this.dataExport(this.table)
      // }
    },

    //fungsi untuk pinda ke page tambah
    // addData() {
    //   // panggil page add data
    //   this.$router.push({ name: "Add Vehicle" });
    // },

    addData() {
      this.$refs.modalAddPage.openModal();
    },

    modalCloseAdd() {
      this.$refs.modalAddPage.closeModal();
      this.getList();
    },

    editVehicle(id) {
      this.$refs.modalEditPage.openModal({ id: id });
      this.getList();
    },

    modalCloseEdit() {
      this.$refs.modalEditPage.closeModal();
      this.getList();
    },

    detailVehicle(id) {
      this.$refs.modalDetailPage.openModal({ id: id });
    },

    modalCloseDetail() {
      this.$refs.modalDetailPage.closeModal();
      this.getList();
    },

    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteVehicle(id);
        }
      });
    },

    // fungsi delete data
    async deleteVehicle(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("fms_vehicle/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle data delete successfully."
        );
        //kembali ke page list
        // this.$router.replace({ name: "List Vehicle" });
        this.getList();
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        console.log("ewww");
        if (type == "all") {
          await this.$store.dispatch("fms_vehicle/list");
          return this.dataExport(await this.$store.getters["fms_vehicle/list"]);
        } else if (type == "filter") {
          var query = {};

          // if(sortBy.length!=0){
          //   var  sort=sortBy[0]
          //   if(sortDesc[0]){
          //     sort="-"+sortBy[0]
          //   }
          //   query.sort = sort
          // }

          if (this.searchValue && this.searchCategory) {
            query.filter = { [this.searchCategory]: this.searchValue };
          }

          if (this.valueVehicleStatus != "") {
            if (query.filter) {
              Object.assign(query.filter, {
                vehicle_status: this.valueVehicleStatus,
              });
            } else {
              query.filter = { vehicle_status: this.valueVehicleStatus };
            }
          }

          // if (this.valueBusinessUnit != 0) {
          //   if (query.filter) {
          //     Object.assign(query.filter, {
          //       vehicle_business_unit: this.valueBusinessUnit,
          //     });
          //   } else {
          //     query.filter = { vehicle_business_unit: this.valueBusinessUnit };
          //   }
          // }

          await this.$store.dispatch("fms_vehicle/list", query);
          return this.dataExport(await this.$store.getters["fms_vehicle/list"]);
        }
      }
    },
    dataExport(data) {
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        var vehicle_body_color = null;
        var vehicle_plate_color = null;
        var vehicle_fuel_type = null;
        // var vehicle_business_unit = null;
        var vehicle_model = null;
        var vehicle_current_status = null;
        var vehicle_general_current_status = null;
        var vehicle_model = null;
        var vehicle_mspf_last_activation_status = null;
        var vehicle_mspf_last_communication_status = null;

        var vehicle_document_type = null;

        var vehicle_accesory_type = null;

        if (value_1.vehicle_status == 0) {
          vehicle_general_current_status = "Idle ";
          vehicle_current_status = "Registered";
        } else if (value_1.vehicle_status == 1) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Waiting Approval";
        } else if (value_1.vehicle_status == 2) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Rejected";
        } else if (value_1.vehicle_status == 3) {
          vehicle_general_current_status = "Available";
          vehicle_current_status = "Waiting PKO";
        } else if (value_1.vehicle_status == 4) {
          vehicle_general_current_status = "Running";
          vehicle_current_status = "Active";
        } else if (value_1.vehicle_status == 5) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Payment Complete";
        } else if (value_1.vehicle_status == 6) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Terminate By Payment";
        } else if (value_1.vehicle_status == 7) {
          vehicle_general_current_status = "Running";
          vehicle_current_status = "Active Ownership";
        } else if (value_1.vehicle_status == 8) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Repo";
        } else if (value_1.vehicle_status == 9) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Return";
        } else if (value_1.vehicle_status == 10) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status =
            "STNK Problem " + value_1.vehicle_stnk_status;
        } else if (value_1.vehicle_status == 11) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "Key Problem " + value_1.vehicle_key_status;
        } else if (value_1.vehicle_status == 12) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status =
            "STNK " +
            value_1.vehicle_stnk_status +
            "& Key Problem " +
            value_1.vehicle_key_status;
        } else if (value_1.vehicle_status == 13) {
          vehicle_general_current_status = "Idle";
          vehicle_current_status = "In Service";
        }

        // console.log(value_1.vehicle_last_mspf_data)
        // console.log(value_1)

        if (value_1.vehicle_last_mspf_data) {
          vehicle_mspf_last_activation_status =
            value_1.vehicle_last_mspf_data.vehicle_mspf_last_activation_status;
          vehicle_mspf_last_communication_status =
            value_1.vehicle_last_mspf_data
              .vehicle_mspf_last_communication_status;
        }

        if (value_1.vehicle_type) {
          vehicle_model =
            value_1.vehicle_type.vehicle_brands.vehicle_brand_name +
            ", " +
            value_1.vehicle_type.vehicle_model +
            " " +
            value_1.vehicle_type.vehicle_year_model;

          if (value_1.vehicle_type.vehicle_fuel_type == 1) {
            vehicle_fuel_type = "Bensin";
          } else if (value_1.vehicle_plate_color == 2) {
            vehicle_fuel_type = "Diesel";
          } else if (value_1.vehicle_plate_color == 3) {
            vehicle_fuel_type = "Listrik";
          } else if (value_1.vehicle_plate_color == 4) {
            vehicle_fuel_type = "Hybrid";
          } else if (value_1.vehicle_plate_color == 5) {
            vehicle_fuel_type = "CNG";
          }
        }

        // if (value_1.vehicle_business_unit) {
        //   vehicle_business_unit =
        //     value_1.vehicle_business_unit.business_unit_name;
        // }

        if (value_1.vehicle_plate_color == 0) {
          vehicle_plate_color = "Kuning";
        } else if (value_1.vehicle_plate_color == 1) {
          vehicle_plate_color = "Hitam";
        }

        if (value_1.vehicle_body_color == 0) {
          vehicle_body_color = "Putih";
        } else if (value_1.vehicle_body_color == 1) {
          vehicle_body_color = "Putih Kuning";
        } else if (value_1.vehicle_body_color == 2) {
          vehicle_body_color = "Putih Metalik";
        } else if (value_1.vehicle_body_color == 3) {
          vehicle_body_color = "Hitam";
        } else if (value_1.vehicle_body_color == 4) {
          vehicle_body_color = "Hitam Metalik";
        } else if (value_1.vehicle_body_color == 5) {
          vehicle_body_color = "Silver";
        } else if (value_1.vehicle_body_color == 6) {
          vehicle_body_color = "Silver Metalik";
        } else if (value_1.vehicle_body_color == 7) {
          vehicle_body_color = "Abu Abu";
        } else if (value_1.vehicle_body_color == 8) {
          vehicle_body_color = "Abu Abu Metalik";
        } else if (value_1.vehicle_body_color == 9) {
          vehicle_body_color = "N/A";
        }

        for (
          let i = 0;
          i <
          Math.max(
            value_1.vehicle_document.length,
            value_1.vehicle_accessory.length
          );
          i++
        ) {
          var data = {
            no:
              dataReturn[index_1] && dataReturn[index_1].no == index_1 + 1
                ? null
                : index_1 + 1,
            vehicle_door_no: value_1.vehicle_door_no,
            vehicle_plate_no: value_1.vehicle_plate_no,
            vehicle_current_status: vehicle_current_status,
            vehicle_general_current_status: vehicle_general_current_status,
            vehicle_mspf_last_activation_status:
              vehicle_mspf_last_activation_status,
            vehicle_mspf_last_communication_status:
              vehicle_mspf_last_communication_status,
            // vehicle_business_unit: vehicle_business_unit,
            vehicle_model: vehicle_model,
            vehicle_fuel_type: vehicle_fuel_type,
            vehicle_body_color: vehicle_body_color,
            vehicle_plate_color: vehicle_plate_color,
            vehicle_registration_year: value_1.vehicle_registration_year,
            vehicle_registration_name: value_1.vehicle_registration_name,
            vehicle_production_year: value_1.vehicle_production_year,
            vehicle_chassis_no: value_1.vehicle_chassis_no,
            vehicle_engine_no: value_1.vehicle_engine_no,
            no_document: value_1.vehicle_document[i] ? i + 1 : null,
            vehicle_document_type: value_1.vehicle_document[i]
              ? this.export_type(
                  "document",
                  value_1.vehicle_document[i].vehicle_document_type
                )
              : null,
            vehicle_document_no: value_1.vehicle_document[i]
              ? value_1.vehicle_document[i].vehicle_document_no
              : null,
            vehicle_document_expire_date: value_1.vehicle_document[i]
              ? value_1.vehicle_document[i].vehicle_document_expire_date
              : null,
            vehicle_document_tax_expire_date: value_1.vehicle_document[i]
              ? value_1.vehicle_document[i].vehicle_document_tax_expire_date
              : null,
            vehicle_document_remark: value_1.vehicle_document[i]
              ? value_1.vehicle_document[i].vehicle_document_remark
              : null,
            no_accesory: value_1.vehicle_accessory[i] ? i + 1 : null,
            vehicle_accesory_type: value_1.vehicle_accessory[i]
              ? this.export_type(
                  "accesory",
                  value_1.vehicle_accessory[i].vehicle_accesory_type
                )
              : null,
            vehicle_accesory_serial_no: value_1.vehicle_accessory[i]
              ? value_1.vehicle_accessory[i].vehicle_accesory_serial_no
              : null,
            vehicle_accesory_installation_date: value_1.vehicle_accessory[i]
              ? value_1.vehicle_accessory[i].vehicle_accesory_installation_date
              : null,
            vehicle_accesory_installation_by: value_1.vehicle_accessory[i]
              ? value_1.vehicle_accessory[i].vehicle_accesory_installation_by
              : null,
            vehicle_accesory_remark: value_1.vehicle_accessory[i]
              ? value_1.vehicle_accessory[i].vehicle_accesory_remark
              : null,
            created_at: value_1.created_at,
            updated_at: value_1.created_at,
          };

          dataReturn.push(data);
        }
      });
      return dataReturn;
    },
    export_type(type, item) {
      var return_data = null;
      if (type == "document") {
        if (item == 0) {
          return_data = "STNK";
        } else if (item == 1) {
          return_data = "BPKB";
        } else if (item == 2) {
          return_data = "KEUR";
        } else if (item == 3) {
          return_data = "TERA";
        } else if (item == 4) {
          return_data = "SRUT";
        } else if (item == 5) {
          return_data = "KP";
        }
      } else if (type == "accesory") {
        if (item == 0) {
          return_data = "RDS+SIM-CARD";
        }
        if (item == 1) {
          return_data = "Bracket RDS";
        }
        if (item == 2) {
          return_data = "Crown";
        }
        if (item == 3) {
          return_data = "Emergency Lamp";
        }
        if (item == 4) {
          return_data = "Vacancy Lamp";
        }
        if (item == 5) {
          return_data = "Sticker";
        }
      }
      return return_data;
    },
    async getFileBulk() {
      this.btnBulkLoad = true;
      // console.log("GET_FILE", this.fileBulkVehicle.name);
      // console.log("CSV_TO_JSON", cvsToJson);

      // let convert = cvsToJson
      //   .parseSubArray("*", ",")
      //   .getJsonFromCsv(this.fileBulkVehicle);

      let reader = new FileReader();
      reader.readAsText(this.fileBulkVehicle);
      reader.onload = async (e) => {
        // console.log("ALREADY_CONVERT", reader.result.replace(/,/g, ";"));

        let converTs = cvsToJson.csvStringToJson(
          reader.result.replace(/,/g, ";")
        );

        // console.log("TO_JSON", converTs);

        if (converTs.length > 55) {
          this.$store.dispatch("alerts/error", "To Much Data Max 50");
        } else {
          let nomorVehicle = this.totalDataTable;
          // let willSendedData = {
          //   type: "fms_vehicles",
          //   data: [],
          // };
          for (let i = 0; i < converTs.length; i++) {
            const dataObj = converTs[i];
            let vehicleId = "";
            if (dataObj.vehicle_type_id == "RIMAU A/T") {
              vehicleId = 1;
            } else if (dataObj.vehicle_type_id == "ANOA A/T") {
              vehicleId = 2;
            } else if (dataObj.vehicle_type_id == "MALEO A/T") {
              vehicleId = 3;
            }

            let vehicleBodyColor = "";
            if (dataObj.vehicle_body_color.toUpperCase() == "PUTIH") {
              vehicleBodyColor = 0;
            } else if (dataObj.vehicle_body_color.toUpperCase() == "HITAM") {
              vehicleBodyColor = 3;
            } else if (
              dataObj.vehicle_body_color.toUpperCase() == "ABU ABU" ||
              dataObj.vehicle_body_color.toUpperCase() == "ABU-ABU"
            ) {
              vehicleBodyColor = 7;
            }

            let noVehicle = nomorVehicle++;
            let exampleData = {
              type: "fms_vehicles",
              vehicle_type_id: vehicleId.toString(),
              vehicle_body_color: vehicleBodyColor.toString(),
              vehicle_registration_year: dataObj.vehicle_registration_year,
              vehicle_plate_no: dataObj.vehicle_plate_no,
              vehicle_chassis_no: dataObj.vehicle_chassis_no,
              vehicle_engine_no: dataObj.vehicle_engine_no,
              vehicle_door_no: noVehicle.toString(), // Di isi dengan length pada vegicle
              vehicle_pool: "4",
              vehicle_production_year: dataObj.vehicle_production_year,
              vehicle_plate_color: "1",
              vehicle_registration_name: "PT Charged Tech Indonesia",
              vehicle_document: [
                {
                  vehicle_document_type: "0", // Only STNK
                  vehicle_document_no: dataObj.vehicle_document_no,
                  vehicle_document_expire_date:
                    dataObj.vehicle_document_expire_date,
                  vehicle_document_tax_expire_date:
                    dataObj.vehicle_document_tax_expire_date,
                },
              ],
              vehicle_accessory: [],
            };
            // willSendedData.data.push(exampleData);
            await this.postData(exampleData);

            if (i < converTs.length - 1) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              // await this.getList();
            }
          }
          await this.$store.dispatch(
            "alerts/success",
            "Successfully Bulk Data Vehicle."
          );
          // console.log("SEND_DATA", willSendedData);
          await this.getList();
          this.menuBulkVehicle = false;
        }
        this.btnBulkLoad = false;
      };
    },

    async postData(data) {
      try {
        await this.$store.dispatch("fms_vehicle/add", data);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}
</style>
